export enum HealthStatus {
  OK = 'ok',
  ERROR = 'error',
}

export interface Health {
  status: HealthStatus;
  info?: {
    [key: string]: {
      status: HealthStatus;
      message?: string;
      count?: number;
    };
  };
  error?: {
    [key: string]: {
      status: HealthStatus;
      message?: string;
    };
  };
  details?: {
    [key: string]: {
      status: HealthStatus;
      message?: string;
      count?: number;
    };
  };
}
